import React, { useState } from 'react';
import { toast } from 'sonner';
import { Switch } from '../../ui/switch';
import { adminApi, errorApi } from './tiendaAdminApi';

export const EstadoBadge = ({ visible, testId }) => (
  <span className={`inline-flex rounded-full px-2.5 py-0.5 text-xs font-semibold ${visible ? 'bg-emerald-100 text-emerald-800' : 'bg-slate-200 text-slate-700'}`} data-testid={testId}>
    {visible ? 'Visible' : 'Oculto'}
  </span>
);

export default function InterruptorVisible({ producto, onCambio }) {
  const [guardando, setGuardando] = useState(false);
  const cambiar = async (visible) => {
    setGuardando(true);
    try {
      const r = await adminApi.visibilidad(producto.id, visible);
      onCambio(r.data);
      toast.success(visible ? 'El producto ya aparece en Mi JPM' : 'El producto quedó oculto para los clientes');
    } catch (e) {
      toast.error(errorApi(e, 'No se pudo cambiar la visibilidad'));
    } finally {
      setGuardando(false);
    }
  };
  return (
    <label className="flex items-center justify-between gap-3 rounded-lg bg-slate-50 px-3 py-2">
      <span className="text-sm font-medium text-slate-700">Visible para clientes</span>
      <span className="flex items-center gap-2">
        <EstadoBadge visible={producto.visible_clientes} testId={`tienda-estado-${producto.id}`} />
        <Switch checked={!!producto.visible_clientes} disabled={guardando} onCheckedChange={cambiar}
          className="min-h-0 data-[state=checked]:bg-emerald-600" data-testid={`tienda-visible-${producto.id}`} />
      </span>
    </label>
  );
}
